import { render, staticRenderFns } from "./commentManagement.vue?vue&type=template&id=61c65e3e&scoped=true"
import script from "./commentManagement.vue?vue&type=script&lang=js"
export * from "./commentManagement.vue?vue&type=script&lang=js"
import style0 from "./commentManagement.vue?vue&type=style&index=0&id=61c65e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c65e3e",
  null
  
)

export default component.exports